export default "__VITE_ASSET__CD7y_Q2B__"